//@ts-nocheck
import { useContext } from 'react';
import ModalContext from './ModalContext';

export default function useModal() : IModalContext {

    const context : IModalContext = useContext(ModalContext);
    return context;
}